import styled from 'styled-components';

import { Button, minWidth, Text, units } from '@calm-web/design-system';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;

export const HeaderText = styled(Text)`
	letter-spacing: 0.17px;
	margin-bottom: ${units(1)};

	${minWidth('tablet')} {
		letter-spacing: 0.15px;
	}
`;

export const BodyText = styled(Text)`
	margin-bottom: ${units(3)};
	letter-spacing: 0.15px;
	font-size: 16px;
`;

export const CtaButton = styled(Button)``;
